import Vuex from 'vuex'
import Vue from "vue";
import {getWithId, patchWithId} from "../request.js";
import ui from "./ui.js";

Vue.use(Vuex);

const {MATT_USER_API} = window;

export default {
  namespaced: true,
  modules: { ui },
  state: {
    data: null,
    noobMode: false,
  },
  mutations: {
    setData(state, data) {
      state.data = data;
      state.noobMode = data.noob;
    },
  },
  actions: {
    async loadData({commit}) {
      try {
        commit('ui/setLoading', 'Loading dashboard data...');
        const url = `${MATT_USER_API}/dashboard`;
        const response = await getWithId(this._vm.$auth, url);
        commit('setData', response.data);
      } finally {
        commit('ui/setLoading');
      }
    },
    async dismissCard({commit, dispatch}, name) {
      try {
        commit('ui/setLoading', 'Dismissing card...');
        const url = `${MATT_USER_API}/userPreferences`;
        await patchWithId(this._vm.$auth, url, { data: { [`dashboard.hide${name}`]: true } });
        await dispatch('loadData');
      } finally {
        commit('ui/setLoading');
      }
    }
  },
};
